import React from 'react'
import styled from 'styled-components'

export type Props = {
  children: React.ReactNode,
  title: string,
  dataCy?:string
}

const StyledContainer = styled.div`
  border-bottom: 1px solid ${props => props.theme.members.colors.silver._30};
  margin-bottom: 1.5rem;
`

const StyledTitle = styled.div`
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.7rem;
  margin-bottom: .5rem;
`

export const StyledJobOfferSearchFormQueryBox: React.FC<Props> = (props: Props) => {
  return (
    <StyledContainer data-cy={props.dataCy && `job-offer-${props.dataCy}-search-form-query-box`}>
      <StyledTitle>{props.title}</StyledTitle>
      {props.children}
    </StyledContainer>
  )
}
